import React, { Component } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Fade } from 'react-awesome-reveal';
import './style.css'
class SolutionWidget extends Component {
  render() {
    let FooterData = this.props.FooterData;
    var { ftitle, onClickService } = this.props;
    const scrollToTop = () => {
      window.scrollTo(0, 0);
    };
    return (
      
        <div className='col-lg-5 col-md-6'>
          <Fade triggerOnce direction="up" duration={1400}>
          <div
            className='f_widget about-widget pl_70 wow fadeInLeft'
            data-wow-delay='0.4s'
          >
            <h3 className='f-title f_600 t_color f_size_18 mb_40 text-center'>SERVICES</h3>
            <div class="service-list">
              <div style={{ flex: "45%" }}  class="left-column">
                <ul>
                  <li>
                  <Link
                      to='/services/content-writers-job'
                      onClick={scrollToTop}
                      role='button'
                      aria-haspopup='true'
                      aria-expanded='false'
                      className="flink"
                    >
                      Content Writers Job
                    </Link>
                  
                  </li>
                  <li>
                  <Link
                      to='/services/fulltime-teacher'
                      onClick={scrollToTop}
                      role='button'
                      aria-haspopup='true'
                      aria-expanded='false'
                      className="flink"
                    >
                      Full/Part Time Teachers
                    </Link>
                  
                  </li>
                  <li>
                  <Link
                      to='/services/fulltime-programmer'
                      onClick={scrollToTop}
                      role='button'
                      aria-haspopup='true'
                      aria-expanded='false'
                      className="flink"
                    >
                      Full/Part Time Programmer
                    </Link>
                 
                  </li>
                  <li>
                  <Link
                      to='/services/homework'
                      onClick={scrollToTop}
                      role='button'
                      aria-haspopup='true'
                      aria-expanded='false'
                      className="flink"
                    >
                     Homework Help
                    </Link>
                  
                  </li>
                  <li>
                  <Link
                      to='/services/assignment-help'
                      onClick={scrollToTop}
                      role='button'
                      aria-haspopup='true'
                      aria-expanded='false'
                      className="flink"
                    >
                     Assignment Help
                    </Link>
                  
                  </li>
                  <li>
                  <Link
                      to='/services/project-help'
                      onClick={scrollToTop}
                      role='button'
                      aria-haspopup='true'
                      aria-expanded='false'
                      className="flink"
                    >
                     Project Help
                    </Link>
                  </li>
                  <li>
                  <Link
                      to='/services/exams-help'
                      onClick={scrollToTop}
                      role='button'
                      aria-haspopup='true'
                      aria-expanded='false'
                      className="flink"
                    >
                     Exam Help
                    </Link>
                  </li>
                  


                </ul>
              </div>
              <div style={{ flex: "35%" }} class="right-column">
                <ul>
                <li>
                <Link
                      to='/services/quizzes-help'
                      onClick={scrollToTop}
                      role='button'
                      aria-haspopup='true'
                      aria-expanded='false'
                      className="flink"
                    >
                     Quizzes Help
                    </Link>
                  </li>
                  <li>
                  <Link
                      to='/services/dissertations-help'
                      onClick={scrollToTop}
                      role='button'
                      aria-haspopup='true'
                      aria-expanded='false'
                      className="flink"
                    >
                     Dissertations Help
                    </Link>
                  </li>
                  <li>
                  <Link
                      to='/services/research-paper-help'
                      onClick={scrollToTop}
                      role='button'
                      aria-haspopup='true'
                      aria-expanded='false'
                      className="flink"
                    >
                     Research Paper Help
                    </Link>
                  </li>
                  <li>
                  <Link
                      to='/services/thesis-help'
                      onClick={scrollToTop}
                      role='button'
                      aria-haspopup='true'
                      aria-expanded='false'
                      className="flink"
                    >
                     Thesis Help
                    </Link>
                  </li>
                  <li>
                  <Link
                      to='/services/lab-report-help'
                      onClick={scrollToTop}
                      role='button'
                      aria-haspopup='true'
                      aria-expanded='false'
                      className="flink"
                    >
                     Lab Report Help
                    </Link>
                  </li>
                  <li>
                  <Link
                      to='/services/term-paper-help'
                      onClick={scrollToTop}
                      role='button'
                      aria-haspopup='true'
                      aria-expanded='false'
                      className="flink"
                    >
                     Term Paper Help
                    </Link>
                  </li>
                  <li>
                  <Link
                      to='/services/case-study-help'
                      onClick={scrollToTop}
                      role='button'
                      aria-haspopup='true'
                      aria-expanded='false'
                      className="flink"
                    >
                     Case Study Help
                    </Link>
                  </li>
                  


                </ul>
              </div>
            </div>
          </div>
          </Fade>
        </div>
        // </Fade>
    );
  }
}

export default SolutionWidget;
